import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {KeycloakProfile} from 'keycloak-js';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    loginForm: FormGroup;
    username: AbstractControl;
    password: AbstractControl;
    public hidePsw = true;
    private isLoggedIn: boolean;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private keyCloakService: KeycloakService) {

        this.loginForm = this.fb.group({
            username: [],
            password: [],
        }, {});

    }

    public userProfile: KeycloakProfile | null = null;

    public async ngOnInit() {
        this.isLoggedIn = await this.keyCloakService.isLoggedIn();

        if (this.isLoggedIn) {
            await this.router.navigate(['/home']);
        } else {
            this.keyCloakService.login({
                redirectUri: environment.baseUrl
            });
        }
    }

    onLogin() {
    }
}
